import { motion } from 'framer-motion';
import { css } from '@emotion/css';
import { Backdrop } from '@mui/material';
import { useEffect, useState } from 'react';
import peachjarLogo from '@/assets/peachjar.png';

interface PeachjarLoaderProps {
  size?: number | string;
  alt?: string;
  loading?: boolean;
}

const styles = {
  container: css({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100vh',
    width: '100%',
  }),
  image: (size: number | string) =>
    css({
      width: size,
      height: size,
      display: 'block',
    }),
};

export const PeachjarLoader: React.FC<PeachjarLoaderProps> = ({
  size = 128,
  loading = true,
  alt = 'Loading...',
}) => {
  const [liveMessage, setLiveMessage] = useState<string>('');

  useEffect(() => {
    if (loading) {
      setLiveMessage(alt);
      const timeout = setTimeout(() => setLiveMessage(''), 1000);
      return () => clearTimeout(timeout);
    }
  }, [loading, alt]);

  return (
    <Backdrop
      open={loading}
      sx={{ color: '#fff', zIndex: theme => theme.zIndex.drawer + 1 }}
      aria-hidden={false}
    >
      <div
        className={styles.container}
        role="status"
        aria-live="polite"
        aria-atomic="true"
        aria-busy={loading}
      >
        <span className="sr-only">{liveMessage}</span>
        <motion.img
          src={peachjarLogo}
          alt=""
          aria-hidden
          className={styles.image(size)}
          animate={{ scale: [1, 1.1, 1] }}
          transition={{
            duration: 0.8,
            repeat: Infinity,
            ease: 'easeInOut',
          }}
        />
      </div>
    </Backdrop>
  );
};
